<mat-form-field color="primary" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    [placeholder]="placeholder"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    [displayWith]="displayFn.bind(this)"
  >
    @for (
      option of filteredOptions$ | async;
      track trackOptionBy($index, option)
    ) {
      <mat-option [value]="option.value">
        {{ option.displayName }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
